import React, {useContext, useEffect, useState, useCallback} from 'react';
import headbandContext from 'contexts/headband';
import Popup from 'reactjs-popup';
import './listeFormation.scss';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import { Eventcalendar, localeFr } from '@mobiscroll/react';
import { googleCalendarSync } from '@mobiscroll/calendar-integration';
import AgendaForm from './agendaForm';
import renderHeader from './renderHeader';
import PdfReader from 'components/pdfReader/pdfReader';
import { QRCodeSVG } from 'qrcode.react';
import PdfFormation from './pdfFormation';
export default function ListeFormation(props) {
    const {setCounter, counterDefault} = props
    const {setHeadband} = useContext(headbandContext);
    const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"]
    const [month, setMonth] = useState(new Date().getMonth());
    const [loadEvents, setLoadEvents] = useState([]);
    const [myEvents, setMyEvents] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const colors = ['#215fa5', '#56b5e6', '#95c11f', '#ea5045', '#fb7433', '#c05b88'];
    useEffect(() => {
        setHeadband({
            title : 'La liste des formations par dates',
            icon : 'picto_formations_dates.svg',
            color : 'bckDarkBlue'
        });
    }, [])
    useEffect(() => {
        // googleCalendarSync.init({
        //     apiKey: 'AIzaSyB_OhcyxOwdpXGQvKneee0WLB_Js2OVQJk',
        //     clientId: '919030223627-9q77k42ak3v975lo5i8efg566salv03r.apps.googleusercontent.com',
        //     scope: 'https://www.googleapis.com/auth/calendar.events.readonly',
        //     onInit : onInit
        // });
        googleCalendarSync.init({
            apiKey: 'AIzaSyAolOgEfcfUabiHlm1_29avKcBJCYlrkeI',
            clientId: '1088473397902-h88qm22fr5vn260nj66q801e99e6hb9o.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/calendar.events.readonly',
            onInit : onInit
        });
        
    }, []);
    const onInit = () => {
        googleCalendarSync.getEvents(
            'totem.chu@gmail.com',  
            // 'anfh.rouen.calendrier@gmail.com',
            new Date(new Date().getFullYear(), 0, 1, 1),
            new Date(new Date().getFullYear(), 11, 31, 23, 59)
        )
        .then(events => {
            setLoadEvents(events);
        })   
        .catch(err => console.log(err))
    };
    const view = { 
        agenda: { 
            type: 'month',
            size : 1
        }
    };
    const onSelectedDateChange = useCallback((event, inst) => {
        setSelectedDate(event.date);
    });
    const setDate = useCallback((year, month) => {
        // Set a specific date
        setCounter(counterDefault)
        setSelectedDate(new Date(year, month, 1));
    });
    const onEventClick = (event, inst) => {
        console.log(event);
    };
    useEffect(() => {
        const events = [...loadEvents];
        events.sort(function compare(a, b) {			
            if (a.googleEvent.start.dateTime < b.googleEvent.start.dateTime)
            return -1;
            if (a.googleEvent.start.dateTime > b.googleEvent.start.dateTime )
            return 1;
            return 0;
        })
        let i = 0;
        for(const event of events){
            let color = event.color;
            color = colors[i];
            if(i < 5) i++;
            else i=0;
            event.color = color;
        }
        setMyEvents(events);
    }, [loadEvents]);
    const renderEvent = useCallback((data) => {
        const startMinute = data.startDate.getMinutes()
		const startHour = data.startDate.getHours()
        const endMinute = data.endDate.getMinutes()
		const endHour = data.endDate.getHours()
        return (
            <Popup
                trigger={
                    <div className='event w100 flex between' style={{backgroundColor : data.color}}>
                        <p style={{width : "800px"}}>
                            {data.title}
                        </p>
                        <p>
                            {
                                (startHour < 10 ? "0" : "" ) + startHour + ":" + (startMinute < 10 ? "0" : "" ) + startMinute + ' / ' + (endHour < 10 ? "0" : "" ) + endHour + ":" + (endMinute < 10 ? "0" : "" ) + endMinute
                            }
                        </p>

                    </div>
                }
                modal
                closeOnDocumentClick
            >
                {
                    close => (
                        <PdfFormation file={data.original.googleEvent && data.original.googleEvent} close={close} setCounter={setCounter} counterDefault={counterDefault} />
                    )
                }
            </Popup>
        );
    });
    const dayOfWeek =(day) => {
        const year = day.date[6] +  day.date[7] + day.date[8] + day.date[9]
        const month =  day.date[3] +  day.date[4]
        const dayNb =  day.date[0] +  day.date[1]
        const dateFormat = new Date(year + "/" + month + "/" + dayNb)
        return (days[dateFormat.getDay() - 1] + " " + dateFormat.getDate())
        // if(day.events[0].startDate.getDay() !== day.events[0].endDate.getDay()) return (days[day.events[0].startDate.getDay()] + " " + day.events[0].startDate.getDate() + " - " + days[day.events[0].endDate.getDay()] + " " + day.events[0].endDate.getDate() )
        // else return days[day.events[0].startDate.getDay()] + " " + day.events[0].startDate.getDate() 
        
    }
    const renderAgenda = useCallback((data) => {
        return <div className="custom-event-list">
            {data.map((day) =>
                <ul className="custom-event-group" key={day.timestamp}>
                    <li className="custom-event-day event-day">{dayOfWeek(day)}</li>
                    {/* <li className="custom-event-day event-day">{day.date }</li> */}
                    {day.events.map((event) =>
                        renderEvent(event)
                    )}
                </ul>,
            )}
        </div>;
    });
    return(
   
        <div id='listeFormation' className='page flex column'>
            <Eventcalendar
                locale={localeFr}
                className='agenda'
                data={myEvents}
                theme="ios"
                themeVariant="light"
                view={view}
                renderHeader={() => renderHeader(setDate, setMonth, month)}
                selectedDate={selectedDate}
                onSelectedDateChange={onSelectedDateChange} 
                onEventClick={onEventClick}
                renderEvent={renderEvent}
                timeFormat={'HH:mm'}
                renderAgenda={renderAgenda}
            />
            <div className='w100 flex center'>
                <div style={{width : "200px"}} className="centerImg">
                    <img src="/finger_blue.svg" alt="" />
                </div>
                <p className='colorDarkBlue'>
                    Cliquer sur une formation pour voir sa fiche
                </p>
            </div>
        </div>
    );
}